import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            isGlobalLoaderActive: 'e/pages/isGlobalLoaderActive',
        }),
    },
    methods: {
        ...mapActions({
            addGlobalLoader: 'e/pages/addGlobalLoader',
            removeGlobalLoader: 'e/pages/removeGlobalLoader',
        }),
    },
}
